import { Instagram, Facebook, ArrowUpRight } from 'lucide-react';

export const SocialMedia = () => {
  return (
    <section data-testid="social-section" className="py-16 md:py-24 bg-[#E31E24] noise-texture">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Text */}
          <div className="text-center md:text-left">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3">
              Folgen Sie unserer elektrisierenden Journey
            </h2>
            <p className="text-white/80 max-w-xl">
              Einblicke in aktuelle Projekte, Tipps rund um Elektrotechnik und Neuigkeiten aus unserem Unternehmen.
            </p>
          </div>
          
          {/* Social Icons */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.instagram.com/fesch.elektrotechnik"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-instagram"
              className="social-icon group"
              aria-label="Instagram"
            >
              <Instagram className="w-6 h-6" />
            </a>
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-facebook"
              className="social-icon group"
              aria-label="Facebook"
            >
              <Facebook className="w-6 h-6" />
            </a>
            
            {/* Follow Button */}
            <a
              href="https://www.instagram.com/fesch.elektrotechnik"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-follow-btn"
              className="hidden sm:flex items-center gap-2 bg-white text-neutral-900 px-6 py-3 font-bold uppercase tracking-wider text-sm hover:bg-neutral-100 transition-colors group"
            >
              Jetzt folgen
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialMedia;
